<template>
  <div class="project-card glass noBorder">
    <div class="card-image">
      <div class="image-wrapper">
        <img :src="props.blogCard.imageUrl" :alt="props.blogCard.title"/>
      </div>
    </div>
    <div class="card-content">
      <div class="card-meta">
          <span v-for="tech in props.blogCard.blogCategoryList?.slice(0, 3)" :key="tech.id" class="glass meta-tag" :style="JSON.parse(tech.style)">
            {{ tech.categoryName }}
          </span>
      </div>
      <h3 class="card-title">{{ props.blogCard.title }}</h3>
      <p class="card-description">{{ props.blogCard.description }}</p>
      <router-link v-if="props.blogCard?.id" :to="
      {
        name: 'blogDetail',
        query: {
          id: props.blogCard.id
        }
      }" rel="noopener noreferrer" class="card-link">
        <span class="link-text">查看博客</span>
        <span class="link-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </span>
      </router-link>
    </div>
  </div>
</template>
<script setup>
import {defineProps} from 'vue'
const props = defineProps(['blogCard'])
</script>

<style scoped>
.project-card {
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.project-card:hover {
  transform: translateY(-6px);
  border-color: var(--laputa-green);
}

.project-card .image-wrapper {
  width: 100%;
  /*height: 200px;*/
  aspect-ratio: 16 / 9;
  border-radius: 0;
  overflow: hidden;
  position: relative;
  /* 图片加载兜底底色，柔和浅绿灰 */
  background: linear-gradient(135deg, #f0f7f3, #e8f1ec);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 底部柔和渐变遮罩，无硬割裂 */
.project-card .image-wrapper::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.45s ease;
}

.project-card:hover .image-wrapper::before {
  opacity: 1;
}

.project-card .image-wrapper img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  /*初始不放大！hover再放大*/
  transform: scale(1);
  transition: all 0.55s cubic-bezier(0.4, 0, 0.2, 1);
}

.project-card:hover .image-wrapper img {
  transform: scale(1.05); /* 放大5%，克制不裁切过多画面 */
}

.project-card .card-content {
  padding: 20px 20px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
}

.project-card .card-meta {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.meta-tag {
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/*.meta-tag:nth-child(1) {
  background: linear-gradient(135deg, #dbeafe, #eff6ff);
  color: #2563eb;
}*/

/*.meta-tag:nth-child(2) {
  background: linear-gradient(135deg, #f3e8ff, #faf5ff);
  color: #7c3aed;
}

.meta-tag:nth-child(3) {
  background: linear-gradient(135deg, #fce7f3, #fdf2f8);
  color: #db2777;
}*/

.meta-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.project-card .card-title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.4;
  margin: 0;
  color: var(--laputa-common-font-color);
  transition: color 0.3s ease;
}

.project-card:hover .card-title {
  color: var(--laputa-green);
}

.project-card .card-description {
  font-size: 0.875rem;
  color: var(--laputa-common-sub-font-color);
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
}

.project-card .card-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--laputa-green);
  color: var(--laputa-card-background-white);
  font-size: var(--laputa-fontsize-15);
  font-weight: 600;
  text-decoration: none;
  border-radius: 12px;
  margin-top: auto;
  transition: all 0.3s ease;
}

.card-link .link-text {
  letter-spacing: 0.3px;
}

.card-link .link-arrow {
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
}

.card-link .link-arrow svg {
  width: 16px;
  height: 16px;
}

.card-link:hover {
  transform: translateY(-2px);
  color: var(--laputa-green);
  border: var(--laputa-border-width) var(--laputa-border-style);
  background: var(--laputa-card-background-white);
}

.card-link:hover .link-arrow {
  transform: translateX(4px);
}

.card-link:active {
  transform: translateY(0);
}

/* ============ 平板适配 768 ~1024px ============ */
@media (min-width: 768px) and (max-width: 1024px) {
  .project-card .image-wrapper {
    aspect‑ratio:16/9;
  }

  .project-card .card-content {
    padding: 18px 18px 22px;
    gap: 13px;
  }

  .project-card .card-title {
    font-size: 1.18rem;
  }

  .project-card .card-description {
    -webkit-line-clamp: 2;
  }

  .card-link {
    padding: 11px 22px !important;
  }
}

/* ============ 手机端 <768px ============ */
@media (max-width: 768px) {
  .project-card:hover .image-wrapper::before {
    opacity: 0;
  }

  .project-card:hover .image-wrapper img {
    transform: scale(1);
  }

  .project-card:active {
    transform: scale(0.98);
  }

  .project-card .card-image {
    padding: 0;
  }

  .project-card .image-wrapper {
    aspect‑ratio:16/9;
    border-radius: 0;
  }

  .project-card .card-content {
    padding: 14px 14px 16px;
    gap: 10px;
  }

  .project-card .card-meta {
    gap: 6px;
  }

  .meta-tag {
    padding: 4px 8px;
    font-size: 0.65rem;
    border-radius: 6px;
  }

  .project-card .card-title {
    font-size: 1.05rem;
  }

  .project-card .card-description {
    font-size: 0.8rem;
    line-height: 1.5;
    -webkit-line-clamp: 2;
  }

  .project-card .card-link {
    padding: 9px 16px;
    font-size: 0.78rem;
    border-radius: 10px;
  }

  .card-link .link-arrow svg {
    width: 13px;
    height: 13px;
  }

  .card-link:active {
    transform: scale(0.97);
  }
}
</style>
